import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }

interface Props{
  hideLine?:boolean,
  wrap?:boolean,
  label?:number|string,
  labelWidth:string,
  alignRight?:boolean,
  hiddenArrow?:boolean,
  require?:boolean,
  modelValue?:string|number,
  clearValue?:any,
  disabled:boolean
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ZCell',
  props: {
    hideLine: { type: Boolean },
    wrap: { type: Boolean },
    label: {},
    labelWidth: { default: '6rem' },
    alignRight: { type: Boolean },
    hiddenArrow: { type: Boolean },
    require: { type: Boolean },
    modelValue: {},
    clearValue: { default: '' },
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props=__props
const emit = __emit
const close=()=>{
  emit("update:modelValue",props.clearValue);
}

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["cell", [_ctx.hideLine?'':'cell-line',_ctx.wrap?'wrap':'']])
  }, [
    _createElementVNode("div", {
      class: "label",
      style: _normalizeStyle({width:_ctx.labelWidth})
    }, [
      _createTextVNode(_toDisplayString(_ctx.label), 1),
      (_ctx.require)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, "*"))
        : _createCommentVNode("", true)
    ], 4),
    _createElementVNode("div", {
      class: _normalizeClass(["flex-1", [_ctx.alignRight?'fixed-right':'']]),
      style: {"font-size":"1.5rem"}
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2),
    (!_ctx.hiddenArrow&&!_ctx.modelValue)
      ? (_openBlock(), _createBlock(_component_van_icon, {
          key: 0,
          name: "arrow",
          class: "arrow-right"
        }))
      : _createCommentVNode("", true),
    (_ctx.modelValue&&!_ctx.disabled)
      ? (_openBlock(), _createBlock(_component_van_icon, {
          key: 1,
          name: "cross",
          class: "arrow-right",
          onClick: close
        }))
      : _createCommentVNode("", true)
  ], 2))
}
}

})